import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  align: {
    type: 'string',
    default: 'full',
  },
  image_small: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  image_large: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  title: {
    type: 'string',
    default: 'Não jogue dinheiro fora. Mude a sua internet.',
  },
  subtitle: {
    type: 'string',
    default:
      'Aqui você economiza, tem internet ultraveloz e não se prende a combos.',
  },
  title_bottom: {
    type: 'string',
    default: 'Por que coletamos esses dados?',
  },
  subtitle_bottom: {
    type: 'string',
    default:
      'Ao informar os seus dados, você concorda com a nossa Política de Privacidade',
  },
  button: {
    type: 'string',
    default: 'Assine pelo WhatsApp',
  },
  ...Common,
};
